import EditInvoiceSettingsModal from './EditInvoiceSettingsModal';

export default EditInvoiceSettingsModal;
